import React from "react";
import ReactDOM from "react-dom/client";
import {CustomModal, CustomModalAction} from "./CustomModal.tsx";
import {Breakpoint} from "@mui/material";

export interface UseCustomModalProps {
    title: string;
    contentText?: string;
    customContent?: React.ReactNode;
    defaultAction: CustomModalAction;
    secondaryAction?: CustomModalAction;
    cancelAction: CustomModalAction;
    width?: Breakpoint | false;
}

export const useCustomModal = (props: UseCustomModalProps) => {
    const [open, setOpen] = React.useState(false);
    const modalRootRef = React.useRef<HTMLDivElement | null>(null);
    const modalRootContainer = React.useRef<ReactDOM.Root | null>(null);

    React.useEffect(() => {
        return () => {
            if (modalRootRef.current) {
                if (modalRootContainer.current) {
                    modalRootContainer.current.unmount();
                }
                if (document.body.contains(modalRootRef.current)) {
                    document.body.removeChild(modalRootRef.current);
                }
            }
        };
    }, []);

    const openModal = () => {
        if (!modalRootRef.current) {
            modalRootRef.current = document.createElement("div");
            document.body.appendChild(modalRootRef.current);
            modalRootContainer.current = ReactDOM.createRoot(modalRootRef.current);
        }
        setOpen(true);
    };

    const handleClose = (action: CustomModalAction) => {
        setOpen(false);

        if (action.method) {
            action.method();
        }
    };

    // Render the modal into the container
    React.useEffect(() => {
        if (modalRootContainer.current && modalRootRef.current) {
            modalRootContainer.current.render(
                <CustomModal
                    open={open}
                    handleClose={handleClose}
                    title={props.title}
                    contentText={props.contentText}
                    customContent={props.customContent}
                    secondaryAction={props.secondaryAction}
                    defaultAction={props.defaultAction}
                    cancelAction={props.cancelAction}
                    width={props.width}
                />
            );
        }
    }, [open, props]);

    return {open: openModal};
};

export default useCustomModal;